import React from 'react';
import { ChecklistWrapper, ForDesktop, ForMobile, ToggleHeading } from './styles';
import { Button, Icons, ToggleContent } from '@myob/myob-widgets';
import { openInNewTab, getRegion } from 'helpers/tools';
import { trackClickInCancellation, ButtonNames } from 'modules/Cancellation/helper';
import { Region } from 'stores/type';

const ChecklistContent: React.FC = () => {
    const handleClick = () => {
        trackClickInCancellation(ButtonNames.LegalTerms);
        let myobLegalNoticesUrl = 'https://www.myob.com/au/support/customer-service/myob-legal-notices';
        if (Region.NZ === getRegion()) {
            myobLegalNoticesUrl = 'https://www.myob.com/nz/support/customer-service/myob-legal-notices';
        }
        openInNewTab(myobLegalNoticesUrl);
    };
    return (
        <div className="content">
            <p>Make sure to follow our cancellation checklist to simplify your cancellation.</p>
            <ul>
                <li>
                    <div>
                        Provide MYOB with a minimum notice period in accordance with your product&apos;s legal notice
                        <Button type="link" onClick={handleClick}>
                            <span data-testid="legal-link">View MYOB&apos;s legal notices here</span>
                        </Button>
                    </div>
                </li>
                <li>Check that your account has no outstanding payments</li>
                <li>Back up your data for your future records</li>
                <li>Inform your account contacts that you&apos;re cancelling</li>
                <li>
                    If you&apos;re a partner of MYOB, please submit this request via MySuccess or contact your Account
                    Manager
                </li>
            </ul>
        </div>
    );
};

const ChecklistHeading: React.FC = () => <h2>The cancellation checklist</h2>;

export const Checklist: React.FC = () => {
    return (
        <ChecklistWrapper>
            <ForMobile>
                <ToggleContent
                    renderContent={({ show, toggle }) => (
                        <ToggleHeading data-testid="mobileHeading" onClick={toggle}>
                            <ChecklistHeading />
                            {show ? <Icons.DownChevron /> : <Icons.RightChevron />}
                        </ToggleHeading>
                    )}
                >
                    <ChecklistContent />
                </ToggleContent>
            </ForMobile>
            <ForDesktop>
                <ChecklistHeading />
                <ChecklistContent />
            </ForDesktop>
        </ChecklistWrapper>
    );
};

export default Checklist;
